import React, { useState, useEffect, useCallback } from "react";
import axios from '../../api/apiClient';

import {
  CreateTableNew as CreateTable,
  SearchBar,
  Button,
  GeneralMessage,
  useGeneralMessage
} from '../../common/APICommon';
import { SetAuditTrail, SetAuditTrailBulk } from './../Reports/AuditTrailReportEmployeeSetup';
import {
  Input
} from '../../common/Input';
import { ConfirmationModal } from '../../common/Modal';
import { token, domain } from '../Security';
import { LoadingSpinner } from '../../common/Loading';
// icon
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteForever';
import { Select } from "../../common/Select";

function PayrollJournalAccount({ user, isHideSideMenu }) {
  // Use the hook for message management
  const { showMessage, message, isSuccess, showGeneralMessage } = useGeneralMessage();

  var headers = [
    "ID",
    "Description",
    "Types",
    "Actions"
  ]
  
  var accessors = [
    "id",
    "description",
    "payrollJournalAccountTypesDisplay",
    "actions"
  ]

  // Type options for the dropdown
  const typeOptions = [
    { value: "TotalBasic", label: "TotalBasic" },
    { value: "TotalGrossPay", label: "TotalGrossPay" },
    { value: "TotalNetPay", label: "TotalNetPay" },
    { value: "TotalAllowance", label: "TotalAllowance" },
    { value: "TotalBenefits", label: "TotalBenefits" },
    { value: "TotalOTRegular", label: "TotalOTRegular" },
    { value: "TotalOTRestday", label: "TotalOTRestday" },
    { value: "TotalOTHolidaySpecial", label: "TotalOTHolidaySpecial" },
    { value: "TotalOTHolidayRegular", label: "TotalOTHolidayRegular" },
    { value: "TotalOTRestdayHolidaySpecial", label: "TotalOTRestdayHolidaySpecial" },
    { value: "TotalOTRestdayHolidayRegular", label: "TotalOTRestdayHolidayRegular" },
    { value: "TotalNighDiff", label: "TotalNighDiff" },
    { value: "TotalLeaves", label: "TotalLeaves" },
    { value: "TotalDeduction", label: "TotalDeduction" },
    { value: "TotalAddition", label: "TotalAddition" },
    { value: "TotalAdjustment", label: "TotalAdjustment" },
    { value: "TotalSSS", label: "TotalSSS" },
    { value: "TotalPagibig", label: "TotalPagibig" },
    { value: "TotalPhilhealth", label: "TotalPhilhealth" },
    { value: "TotalTax", label: "TotalTax" },
    { value: "TotalUndertime", label: "TotalUndertime" },
    { value: "TotalLate", label: "TotalLate" },
    { value: "TotalAbsents", label: "TotalAbsents" },
    { value: "TotalPagibigCalamityLoan", label: "TotalPagibigCalamityLoan" },
    { value: "TotalPagibigLoan", label: "TotalPagibigLoan" },
    { value: "TotalSSSCalamityLoan", label: "TotalSSSCalamityLoan" },
    { value: "TotalSSSLoan", label: "TotalSSSLoan" },
    { value: "TotalCompanyLoan", label: "TotalCompanyLoan" },
    { value: "TotalCashAdvance", label: "TotalCashAdvance" },
    { value: "TotalOtherCashAdvance", label: "TotalOtherCashAdvance" },
    { value: "TotalRegularHolidays", label: "TotalRegularHolidays" },
    { value: "TotalSpecialNonWorkingHolidays", label: "TotalSpecialNonWorkingHolidays" },
    { value: "TotalNighDiffAmount", label: "TotalNighDiffAmount" }
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [data, setData] = useState([]);
  const [selectedData, setSelectedData] = useState(null);

  // Form state
  const [form, setForm] = useState({
    description: "",
    payrollJournalAccountTypes: [] // Array of selected type objects {description}
  });

  const resetLocalVariables = () => {
    setForm({
      description: "",
      payrollJournalAccountTypes: []
    });
    setSelectedData(null);
  }

  // Retrieve
  const [filterData, setFilterData] = useState([]);
  // Add
  const [showAddForm, setShowAddForm] = useState(false);
  // Update
  const [showEditForm, setShowEditForm] = useState(false);
  // Delete
  const [showDeleteForm, setShowDeleteForm] = useState(false);

  const apiUrl = domain + "/api/PayrollJournalAccount";

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      // Transform data for display
      const transformedData = response.data.map(item => ({
        ...item,
        payrollJournalAccountTypesDisplay: item.payrollJournalAccountTypes
          ?.map(type => type.description)
          .join(", ") || "No types"
      }));
      
      setData(transformedData);
      setFilterData(transformedData);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, [apiUrl]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleFilter = (value) => {
    setCurrentPage(1);
    const lowercaseValue = value.toLowerCase();
    
    if (!value) {
      // If input is empty, reset to original list
      setData(filterData);
      return;
    }

    const res = filterData.filter((f) => {
      const match1 = f.description?.toString().toLowerCase().includes(lowercaseValue);
      const match2 = f.id?.toString().startsWith(lowercaseValue);
      const match3 = f.payrollJournalAccountTypesDisplay?.toString().toLowerCase().includes(lowercaseValue);
      return match1 || match2 || match3;
    });
    
    setData(res);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    // Prepare data for API
    const apiData = {
      description: form.description || "",
      payrollJournalAccountTypes: form.payrollJournalAccountTypes.map(type => ({
        description: type.value || type.description
      }))
    };

    console.log('Add Submitting data:', apiData);

    try {
      setLoadingRequest(true);
      await axios.post(apiUrl, apiData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      // Audit trail logic
      await SetAuditTrail({
        setupArea: "Payroll Journal Account", 
        actionTaken: "insert", 
        field: "Add", 
        newValue: `${apiData.description}`, 
        oldValue: "-", 
        dateSaved: new Date(), 
        savedById: user.id
      });
      
      await fetchData();

      showGeneralMessage("Payroll Journal Account created successfully!", true);
      closeAddHandleClick();
    } catch (error) {
      console.error('Error creating data:', error.response || error);

      const errorMessage = error.response?.data?.message ||
        error.response?.data?.errors?.[0]?.message ||
        "Failed to create payroll journal account";
      showGeneralMessage(errorMessage, false);
    } finally {
      setLoadingRequest(false);
    }
  };

  const handleUpdate = async (event) => {
    event.preventDefault();

    if (!selectedData?.id) {
      showGeneralMessage("No record selected for update", false);
      return;
    }

    const apiData = {
      description: form.description || "",
      payrollJournalAccountTypes: form.payrollJournalAccountTypes.map(type => ({
        description: type.value || type.description
      }))
    };

    try {
      setLoadingRequest(true);
      await axios.put(`${apiUrl}/${selectedData.id}`, apiData, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      // Audit trail logic
      let auditInfo = [];

      if(apiData.description !== selectedData.description){
        auditInfo.push({
          setupArea: "Payroll Journal Account",
          actionTaken: "update",
          field: "Description",
          newValue: `${apiData.description}`,
          oldValue: `${selectedData.description}`,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }

      // Compare types
      const newTypes = apiData.payrollJournalAccountTypes.map(type => type.description).sort();
      const oldTypes = selectedData.payrollJournalAccountTypes?.map(type => type.description).sort() || [];
      
      if (JSON.stringify(newTypes) !== JSON.stringify(oldTypes)) {
        const newTypeNames = form.payrollJournalAccountTypes.map(type => type.label || type.description).join(", ");
        const oldTypeNames = selectedData.payrollJournalAccountTypes?.map(type => type.description).join(", ") || "None";
        
        auditInfo.push({
          setupArea: "Payroll Journal Account",
          actionTaken: "update",
          field: "Types",
          newValue: newTypeNames,
          oldValue: oldTypeNames,
          dateSaved: new Date(),
          savedById: user.id,
        });
      }

      if (auditInfo.length > 0) {
        await SetAuditTrailBulk({data: auditInfo});
      }

      setShowEditForm(false);
      await fetchData();

      showGeneralMessage("Payroll Journal Account updated successfully!", true);
      closeEditHandleClick();
    } catch (error) {
      console.error('Error updating data:', error.response || error);

      const errorMessage = error.response?.data?.message ||
        error.response?.data?.errors?.[0]?.message ||
        "Failed to update payroll journal account";
      showGeneralMessage(errorMessage, false);
    } finally {
      setLoadingRequest(false);
    }
  };

  const handleDelete = async () => {
    if (!selectedData?.id) {
      showGeneralMessage("No record selected for deletion", false);
      return;
    }

    try {
      setLoadingRequest(true);
      await axios.delete(`${apiUrl}/${selectedData.id}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      // Audit trail logic
      await SetAuditTrail({
        setupArea: "Payroll Journal Account", 
        actionTaken: "delete", 
        field: "Delete", 
        newValue: `${selectedData.description}`, 
        oldValue: "-", 
        dateSaved: new Date(), 
        savedById: user.id
      });
      
      await fetchData();

      showGeneralMessage("Payroll Journal Account deleted successfully!", true);
      closeDeleteHandleClick();
    } catch (error) {
      console.error('Error deleting data:', error.response || error);

      const errorMessage = error.response?.data?.message ||
        error.response?.data?.errors?.[0]?.message ||
        "Failed to delete payroll journal account";
      showGeneralMessage(errorMessage, false);
    } finally {
      setLoadingRequest(false);
    }
  };

  const editHandleClick = (data) => {
    setSelectedData(data);

    setForm({
      description: data.description || "",
      payrollJournalAccountTypes: data.payrollJournalAccountTypes?.map(type => ({
        value: type.description,
        label: type.description
      })) || []
    });
    openEditHandleClick();
  };

  const deleteHandleClick = (data) => {
    setSelectedData(data);
    setShowDeleteForm(true);
  };

  const openAddHandleClick = () => {
    setShowAddForm(true);
  };

  const closeAddHandleClick = () => {
    setShowAddForm(false);
    resetLocalVariables();
  };

  const openEditHandleClick = () => {
    setShowEditForm(true);
  };

  const closeEditHandleClick = () => {
    setShowEditForm(false);
    resetLocalVariables();
  };

  const openDeleteHandleClick = () => {
    setShowDeleteForm(true);
  };

  const closeDeleteHandleClick = () => {
    setShowDeleteForm(false);
    setSelectedData(null);
  };

  const addType = (typeValue) => {
    if (!typeValue) return;
    
    const selectedType = typeOptions.find(opt => opt.value === typeValue);
    if (!selectedType) return;

    // Check if already added
    if (form.payrollJournalAccountTypes.some(type => type.value === selectedType.value)) {
      showGeneralMessage(`${selectedType.label} is already added.`, false);
      return;
    }

    setForm(prev => ({
      ...prev,
      payrollJournalAccountTypes: [...prev.payrollJournalAccountTypes, selectedType]
    }));
  };

  const removeType = (typeValue) => {
    setForm(prev => ({
      ...prev,
      payrollJournalAccountTypes: prev.payrollJournalAccountTypes.filter(type => type.value !== typeValue)
    }));
  };

  const actions = [
    {
      name: "Edit",
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center",
      function: editHandleClick,
      visible: true,
    },
    {
      name: "Delete",
      tooltip: "delete",
      icon: <DeleteIcon fontSize="small" />,
      className: "bg-red-500 hover:bg-red-600 flex items-center",
      function: deleteHandleClick,
      visible: true,
    },
  ];

  return (
    <div>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl">
            <div className="mainteHeader">
              <div className='sub-title row'>
                <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>{"Maintenance >"} </span>
                <span style={{ borderBottom: "1px solid black" }}>{"Payroll Journal Account"}</span>
              </div>
              <h3>Payroll Journal Account</h3>
            </div>
            <div className='space-y-4 p-4'>
              <SearchBar handleFilter={handleFilter} />

              <Button icon={<AddIcon />}
                name={"Add Payroll Journal Account"}
                className={"bg-customGreen hover:bg-customGreenHover border-none cursor-pointer"}
                onClick={openAddHandleClick}
              />
              <CreateTable
                tableName={"Payroll Journal Accounts"}
                headers={headers}
                accessors={accessors}
                data={data}
                actions={actions}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                itemsPerPage={10}
                totalItems={data?.length}
              />
            </div>
          </div>
        </div>
      </div>
      
      {/* Add Form */}
      <AddEditForm
        isOpen={showAddForm}
        onClose={closeAddHandleClick}
        form={form}
        setForm={setForm}
        handleSubmit={handleSubmit}
        modalName={"Add Payroll Journal Account"}
        mode="add"
        typeOptions={typeOptions}
        addType={addType}
        removeType={removeType}
        showGeneralMessage={showGeneralMessage}
      />
      
      {/* Edit Form */}
      <AddEditForm
        isOpen={showEditForm}
        onClose={closeEditHandleClick}
        form={form}
        setForm={setForm}
        handleSubmit={handleUpdate}
        modalName={"Update Payroll Journal Account"}
        mode="edit"
        typeOptions={typeOptions}
        addType={addType}
        removeType={removeType}
        showGeneralMessage={showGeneralMessage}
      />
      
      {/* Delete Confirmation Modal */}
      <ConfirmationModal
        visible={showDeleteForm}
        onClose={closeDeleteHandleClick}
        onConfirm={handleDelete}
        title="Delete Payroll Journal Account"
        message="Are you sure you want to delete this payroll journal account?"
        confirmText="Delete"
        cancelText="Cancel"
        type="danger"
        isLoading={loadingRequest}
      />

      {/* Use the reusable GeneralMessage component */}
      <GeneralMessage
        form={showMessage}
        message={message}
        isSuccess={isSuccess}
      />

      <LoadingSpinner loading={loadingRequest || loading} />

    </div>
  )
}

function AddEditForm({
  isOpen,
  modalName,
  onClose,
  form,
  setForm,
  handleSubmit,
  mode = "add", // "add", "edit"
  typeOptions,
  addType,
  removeType,
  showGeneralMessage // Pass the showGeneralMessage function from parent
}) {
  const [errorState, setErrorState] = useState({
    description: false,
    types: false
  });
  const [selectedTypeValue, setSelectedTypeValue] = useState("");

  const submit = (e) => {
    e.preventDefault();
    
    // Validation
    const newErrorState = {
      description: !form.description,
      types: form.payrollJournalAccountTypes.length === 0
    };
    
    if (newErrorState.description || newErrorState.types) {
      setErrorState(newErrorState);
      
      return;
    }
    
    handleSubmit(e);
    setErrorState({ description: false, types: false });
  };

  const handleClose = () => {
    onClose();
    setErrorState({ description: false, types: false });
    setSelectedTypeValue("");
  };

  const handleInputChange = (field, value) => {
    setForm(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleAddType = () => {
    if (!selectedTypeValue) {
      showGeneralMessage("Please select a type first", false);
      return;
    }
    addType(selectedTypeValue);
    setSelectedTypeValue("");
    // Clear types error if we're adding a type
    if (errorState.types) {
      setErrorState(prev => ({ ...prev, types: false }));
    }
  };

  if (!isOpen) return null;

  const isEditMode = mode === "edit";

  return (
    <>
      <div
        role="dialog"
        aria-modal="true"
        className="fixed inset-0 z-[10000] flex items-center justify-center overflow-auto bg-black/50 p-3 text-gray-700"
      >
        <div className="relative flex h-auto max-h-[90vh] w-full flex-col rounded-lg bg-gray-50 shadow-xl md:w-[90%] lg:w-[50%] xl:w-[50%]">

          {/* Header */}
          <div className="sticky top-0 z-10 flex items-center justify-between rounded-t-lg border-b border-gray-200 bg-white px-6 py-2 shadow-sm">
            <h2 className="flex items-center space-x-2 text-xl font-semibold text-gray-800">
              <span className="text-xl text-gray-600">{modalName}</span>
            </h2>

            <button
              onClick={handleClose}
              className="border-none bg-transparent p-1 text-gray-400 transition-colors hover:text-gray-700"
              aria-label="Close modal"
            >
              <CloseIcon fontSize="medium" />
            </button>
          </div>

          {/* Body */}
          <div className="flex-grow space-y-4 overflow-y-auto p-6">

            {/* Payroll Journal Account Form */}
            <div className="rounded-lg border border-gray-300 bg-white px-4 shadow-sm">
              <div className="border-b border-gray-300 py-1">
                <h3 className="font-medium text-gray-700">Payroll Journal Account Information</h3>
              </div>
              <div className="grid grid-cols-1 gap-4 pb-3 pt-3">
                <Input
                  label="Description:"
                  value={form.description}
                  onChange={(e) => handleInputChange('description', e.target.value)}
                  placeholder="Enter description"
                  isRequired={true}
                  error={errorState.description && !form.description}
                  errorMessage="Please fill up this field"
                />
                
                <div className="space-y-3 pt-2">
                  <div className="flex items-center space-x-2">
                    <Select
                      label="Add Type:"
                      value={selectedTypeValue}
                      onChange={(e) => setSelectedTypeValue(e.target.value)}
                      options={typeOptions}
                      placeholder="Select type"
                      isRequired={true}
                      className="flex-grow"
                      error={errorState.types && form.payrollJournalAccountTypes.length === 0}
                    />
                    <button
                      type="button"
                      onClick={handleAddType}
                      className="mt-6 rounded border-none bg-green-500 px-2.5 py-2 text-sm text-white hover:bg-green-600"
                    >
                      Add
                    </button>
                  </div>
                  
                  <div>
                    <label className="mb-2 block text-sm font-medium text-gray-600">
                      Selected Types ({form.payrollJournalAccountTypes.length}):
                    </label>
                    {form.payrollJournalAccountTypes.length > 0 ? (
                      <div className="max-h-40 overflow-y-auto rounded border border-gray-200 p-2">
                        {form.payrollJournalAccountTypes.map((type) => (
                          <div key={type.value} className="flex items-center justify-between px-2 py-1 hover:bg-gray-50">
                            <span>{type.label}</span>
                            <button
                              type="button"
                              onClick={() => removeType(type.value)}
                              className="rounded-md border-none bg-red-400 px-2 py-1 text-sm text-white hover:bg-red-500"
                            >
                              Remove
                            </button>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className={`p-3 border ${errorState.types ? 'border-red-300 bg-red-50' : 'border-gray-200 bg-gray-50'} rounded`}>
                        <span className={`text-sm ${errorState.types ? 'text-red-600' : 'text-gray-500'}`}>
                          {errorState.types ? 'Please add at least one type' : 'No types added yet'}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

          </div>

          {/* Footer */}
          <div className="flex justify-end space-x-2 rounded-b-lg border-t border-gray-200 bg-white p-5 shadow-sm">
            <button
              onClick={handleClose}
              className="cursor-pointer rounded border-none bg-gray-400 px-4 py-2 text-white transition-colors hover:bg-gray-500"
            >
              Cancel
            </button>

            <button
              onClick={submit}
              className="cursor-pointer rounded border-none bg-blue-500 px-4 py-2 text-white transition-colors hover:bg-blue-600"
            >
              {isEditMode ? "Update" : "Save"}
            </button>
          </div>

        </div>
      </div>
    </>
  );
}

export default PayrollJournalAccount